import axios from "axios";
import {
  CustomerQuotaAndCallsSuccess,
  CustomerQuotaAndCallsFail,
} from "../constant";
import { Api } from "../../Config/config.js";
import { store } from "../store";

export const CustomerQuotaAndCalls = async (dispatch, accountID) => {
  try {
    const response = await axios.get(`${Api}quota/minAndCallsCalc/`, {
      params: { accountID },

      headers: {
        "Content-Type": "application/json",
        Authorization:
            "Bearer " + store.getState().authReducer.tokens.access.token,
      },
    });

    dispatch({
      type: CustomerQuotaAndCallsSuccess,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: CustomerQuotaAndCallsFail,
      payload: error.response.data,
    });
  }
};

